<template>
  <div id="form">
    <b-row class="row">
      <b-col cols="5">
        <text-input
          :label="$t('LABEL')"
          v-model='labelInput'
          required
          :disabled="!edit"
          borderbottom
          placeholder=""
        />
      </b-col>
      <b-col cols="2"></b-col>
      <b-col cols="5">
        <text-input
          :label="$t('VEHICLE_TYPE')"
          v-model='vehicleTypeInput'
          required
          :disabled="!edit"
          borderbottom
          placeholder=""
        />
      </b-col>
    </b-row>
    <b-row class="row">
      <b-col cols="5">
        <text-input
          :label="$t('CHASSIS_NUMBER')"
          v-model='chassisNumberInput'
          required
          :disabled="!edit"
          borderbottom
          placeholder=""
        />
      </b-col>
      <b-col cols="2"></b-col>
      <b-col cols="5">
        <text-input
          :label="$t('PAINTING_COLOR')"
          v-model='paintingColorInput'
          required
          :disabled="!edit"
          borderbottom
          placeholder=""
        />
      </b-col>
    </b-row>
    <b-row class="row">
      <b-col cols="5">
        <text-input
          :label="$t('VEHICLE_ID')"
          v-model='vehicleIdInput'
          required
          :disabled="!edit"
          borderbottom
          placeholder=""
        />
      </b-col>
      <b-col cols="2"></b-col>
      <b-col cols="5">
        <text-input
          :label="$t('LICENSE_PLATE')"
          v-model='licensePlateInput'
          required
          :disabled="!edit"
          borderbottom
          placeholder=""
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { computed, onMounted, ref, watch } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import TextInput from '@/components/TextInput';

const { useState, useActions } = createNamespacedHelpers('contractNew');

export default {
  name: 'AuthorizedForm',
  components: {
    TextInput,
  },
  props: {
    edit: {
      type: Boolean,
      default: true,
    },
    value: Boolean,
  },
  setup(props, { emit }) {
    const { asset } = useState(['asset']);
    const { setAsset } = useActions(['setAsset']);

    const labelInput = ref('');
    const vehicleTypeInput = ref('');
    const chassisNumberInput = ref('');
    const paintingColorInput = ref('');
    const vehicleIdInput = ref('');
    const licensePlateInput = ref('');

    const setData = () => {
      const data = {
        meta: {
          label: labelInput.value,
          vehicleType: vehicleTypeInput.value,
          chassisNumber: chassisNumberInput.value,
          paintingColor: paintingColorInput.value,
          vehicleId: vehicleIdInput.value,
          licensePlate: licensePlateInput.value,
        }
      };
      setAsset(data);
    };

    const setDataFromState = () => {
      if ('label' in asset.value.meta) {
        labelInput.value = asset.value.meta.label;
      }

      if ('vehicleType' in asset.value.meta) {
        vehicleTypeInput.value = asset.value.meta.vehicleType;
      }

      if ('chassisNumber' in asset.value.meta) {
        chassisNumberInput.value = asset.value.meta.chassisNumber;
      }

      if ('paintingColor' in asset.value.meta) {
        paintingColorInput.value = asset.value.meta.paintingColor;
      }

      if ('vehicleId' in asset.value.meta) {
        vehicleIdInput.value = asset.value.meta.vehicleId;
      }

      if ('licensePlate' in asset.value.meta) {
        licensePlateInput.value = asset.value.meta.licensePlate;
      }
    };

    const valid = computed(() => {
      const conditions = [
        labelInput.value.length > 0,
        vehicleTypeInput.value.length > 0,
        chassisNumberInput.value.length > 0,
        paintingColorInput.value.length > 0,
        vehicleIdInput.value.length > 0,
        licensePlateInput.value.length > 0,
      ];

      return !conditions.includes(false);
    });

    watch(valid, () => emit('input', valid.value));

    watch(asset, setDataFromState);
    onMounted(setDataFromState);

    return {
      setData,
      labelInput,
      vehicleTypeInput,
      chassisNumberInput,
      paintingColorInput,
      vehicleIdInput,
      licensePlateInput,
    };
  }
};
</script>
<style lang='scss' scoped>
@import "~@/assets/scss/colors";

#form {
  .row {
    margin-bottom: 30px;
  }
}

</style>
